module.exports = __webpack_public_path__ + "static/media/swiftly.68fa7624.mp3";